<template>
  <div>
    <ActivitiesCom :link="link" :title="title" :subTitle="subTitle" />
  </div>
</template>

<script>
import ActivitiesCom from "./components/activities/activitiesPageCom.vue";
export default {
  components: { ActivitiesCom },
  data() {
    return {
      link: [
        {
          path:
            "https://us8.campaign-archive.com/?e=[UNIQID]&u=8a202f636c3cdf68cf4522eaf&id=85a67f491a",
          title: "home.latest_news3"
        }
      ],
      title: "home.home_other_activities",
      All: true,
      none: false,
      lanclass: window.localStorage.watchImg,

      contentStyleObj: {
        height: ""
      }
    };
  },
  methods: {
    gernerateId: function(index) {
      return "gernerate_" + index;
    }
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 30px;
  display: flex;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

  b {
    margin-bottom: 10%;
    font-weight: 700;
    color: rgb(153, 204, 0);
    font-size: 30px;
    line-height: 36px;
  }

  .content {
    width: 80%;
    margin-left: 5%;
    text-align: left;
  }

  a {
    cursor: pointer;
    font-size: 14px;
    color: #256daf;
  }

  a:visited {
    text-decoration: none;
    color: #256daf;
  }

  a:hover {
    color: #165896;
  }
  .news_list {
    margin: 20px 0;
  }
}
</style>
